import { Footer } from "../components/Footer";
import { Navbar } from "../components/Navbar";

export const Shoes = () => {
  return (
    <div>
      <Navbar />
          <h2>shoes</h2>
          <Footer/>
    </div>
  );
};
